/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Input,
    Button
} from "reactstrap";

import routes from "routes.js";
import AuthService from "services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Deco from "security/deco"

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            dropdownOpen: false,
            color: "transparent",
            fullname: ""
        };
        this.toggle = this.toggle.bind(this);
        this.dropdownToggle = this.dropdownToggle.bind(this);
        this.sidebarToggle = React.createRef();
    }
    toggle() {
        if (this.state.isOpen) {
            this.setState({
                color: "transparent",
            });
        } else {
            this.setState({
                color: "dark",
            });
        }
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }
    dropdownToggle(e) {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
    getBrand() {
        return this.props.title;
    }
    openSidebar() {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    }
    // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
    updateColor() {
        if (window.innerWidth < 993 && this.state.isOpen) {
            this.setState({
                color: "dark",
            });
        } else {
            this.setState({
                color: "transparent",
            });
        }
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateColor.bind(this));
        this.getFullNameUser()
    }
    componentDidUpdate(e) {
        if (
            window.innerWidth < 993 &&
            e.history.location.pathname !== e.location.pathname &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            this.sidebarToggle.current.classList.toggle("toggled");
        }
    }

    logout() {
        Swal.fire({
            title: 'Xác nhận',
            text: 'Bạn có chắc chắn muốn đăng xuất?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Đăng xuất',
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                AuthService.logout()
            }
        })
    }

    getFullNameUser() {
        const user = JSON.parse(Deco(localStorage.getItem('user')));
        this.setState({ fullname: user.fullname })
    }

    render() {
        return (
            <Navbar
                color="light"
                expand="lg"
                className="navbar-absolute fixed-top"
                style={{
                    boxShadow: "0 2px 5px 0 rgba(0,0,0,.1)",
                    backgroundColor: "#ffffff"
                }}
            >
                <Container fluid>
                    {/* Left side menu toggle - always visible */}
                    <div className="navbar-toggle">
                        <button
                            type="button"
                            ref={this.sidebarToggle}
                            className="navbar-toggler"
                            onClick={() => this.openSidebar()}
                            style={{
                                padding: "10px",
                                borderRadius: "5px",
                                transition: "all 0.3s ease"
                            }}
                        >
                            <span className="navbar-toggler-bar bar1" />
                            <span className="navbar-toggler-bar bar2" />
                            <span className="navbar-toggler-bar bar3" />
                        </button>
                    </div>

                    {/* Brand for desktop - left aligned (d-none d-lg-block) */}
                    <NavbarBrand
                        className="d-none d-lg-block"
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            padding: "10px 15px",
                            transition: "all 0.3s ease",
                            color: "#333"
                        }}
                    >
                        {this.getBrand()}
                    </NavbarBrand>

                    {/* Brand for mobile - center aligned (d-lg-none) */}
                    <NavbarBrand
                        className="d-lg-none mx-auto"
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            padding: "10px 15px",
                            transition: "all 0.3s ease",
                            color: "#333",
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)"
                        }}
                    >
                        {this.getBrand()}
                    </NavbarBrand>

                    {/* Right side toggler - always at the right */}
                    <NavbarToggler
                        onClick={this.toggle}
                        style={{
                            padding: "8px",
                            borderRadius: "5px",
                            marginLeft: "auto"
                        }}
                    >
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                    </NavbarToggler>

                    <Collapse
                        isOpen={this.state.isOpen}
                        navbar
                        className="justify-content-end"
                    >
                        <Nav navbar className="align-items-center mr-3">
                            <NavItem style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                padding: "8px 15px"
                            }} className="d-flex align-items-center">
                                <i className="fa fa-user-circle mr-2" style={{ fontSize: "18px" }} aria-hidden="true"></i>
                                {this.state.fullname}
                            </NavItem>
                        </Nav>
                        <Nav navbar>
                            <NavItem>
                                <Button
                                    color="danger"
                                    onClick={() => this.logout()}
                                    style={{
                                        borderRadius: "30px",
                                        padding: "8px 15px",
                                        transition: "all 0.3s ease",
                                        fontWeight: "500"
                                    }}
                                    className="d-flex align-items-center"
                                >
                                    <i className="fa fa-sign-out mr-2" aria-hidden="true"></i>
                                    <span>Đăng xuất</span>
                                </Button>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        );
    }
}

export default Header;
